"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require("./classes/Dictionary");

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  XXS: "$100 - $1,000",
  XS: "$1,000 - $5,000",
  S: "$5,000 - $10,000",
  M: "$10,000 - $25,000",
  L: "$25,000 - $100,000",
  XL: "$100,000 - $500,000",
  XXL: "$500,000 - $1,000,000",
  XXXL: "More than $1,000,000"
});